import { render } from "./fugaonews.vue?vue&type=template&id=6884f902&scoped=true"
import script from "./fugaonews.vue?vue&type=script&lang=js"
export * from "./fugaonews.vue?vue&type=script&lang=js"

import "./fugaonews.vue?vue&type=style&index=0&id=6884f902&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6884f902"]])

export default __exports__